import { ReactLenis } from "lenis/react";

export const SmoothScroll = ({ children }) => {
  return (
    <ReactLenis
      root
      options={{ lerp: 0.09, duration: 1.2, smoothWheel: true }}
    >
      {children}
    </ReactLenis>
  );
};

export default SmoothScroll;
